import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/index/index.vue'
import { useQuesPageview } from '@/hooks'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  // 登录页面
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
  },
  // 我的答题
  {
    path: '/person',
    name: 'Person',
    redirect: '/person/home',
    component: () => import('../views/person/index.vue'),
    children: [
      {
        path: 'home',
        name: 'person-home',
        component: () => import('../views/person/home.vue'),
      },
      // 参赛排行
      {
        path: 'competitionrank',
        name: 'competition-rank',
        component: () => import('../views/person/competition-rank.vue'),
      },
      // 个人成绩排名
      {
        path: 'rank',
        name: 'person-rank',
        component: () => import('../views/person/rank.vue'),
      },
      // 个人基本信息
      {
        path: 'info',
        name: 'person-info',
        component: () => import('../views/person/info.vue'),
      },
      // 填报记录
      {
        path: 'record',
        title: '填报记录',
        name: 'person-record',
        component: () => import('../views/person/record.vue'),
      },
      // 积分记录
      {
        path: 'recordScoreList',
        name: 'record-score-list',
        component: () => import('../views/person/record-score-list'),
      },
      // 抽奖-中奖记录
      {
        path: 'prizes',
        name: 'prizes-record',
        component: () => import('../views/person/prizes-record.vue'),
      },
      // 领奖证书
      {
        path: 'certificate',
        name: 'certificate',
        component: () => import('../views/person/certificate.vue'),
      }
    ],
  },
  // 结果页面
  {
    path: '/result',
    name: 'result',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/result/index.vue'),
  },
  // 问卷结果
  {
    path: '/ques-result',
    name: 'ques-result',
    component: () => import('../views/result/quesResult.vue'),
  },
  // 多题展示
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list/index.vue'),
  },
  // 单题展示
  {
    path: '/single/:id',
    name: 'single',
    meta: {
      // 开启动画
      transition: true,
      transitionName: '',
    },
    component: () => import('../views/single/index.vue'),
  },
  // 错误页面
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error/index.vue'),
  },
  // 闯关竞赛模式
  {
    path: '/competition',
    name: 'competition',
    redirect: '/competition/home',
    component: () => import('../views/competition/index.vue'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/competition/home.vue'),
      },
      {
        path: 'question',
        name: 'question',
        component: () => import('../views/competition/question.vue'),
      },
       // pk匹配加载页
       {
        path: 'pk-loading',
        name: 'pk-loading',
        component: () => import('../views/competition/pkLoading.vue'),
      },
      // pk结果页
      {
        path: 'pk-result',
        name: 'pk-result',
        component: () => import('../views/competition/pkResult.vue'),
      },
      {
        path: 'result',
        name: 'c-result',
        component: () => import('../views/competition/result.vue'),
      },
      {
        path: 'result-new',
        name: 'c-result-new',
        component: () => import('../views/competition/resultNew.vue'),
      },
    ],
  },
  // 活动相关
  {
    path: '/activity',
    name: 'activity',
    component: () => import('../views/activity/index.vue'),
    children: [
      {
        path: 'home',
        name: 'activity-home',
        component: () => import('../views/activity/home.vue'),
      },
      // 单位列表
      {
        path: 'list',
        name: 'activity-list',
        component: () => import('../views/activity/list.vue'),
      },
    ],
  },
  // 管理面板
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/index.vue'),
  },
  // 临时页面
  {
    path: '/tmpResult',
    name: 'tmpResult',
    component: () => import('../views/tmp/quesResult.vue'),
  },
  // 山东卫视定制界面
  {
    path: '/custom/sdws',
    name: 'sdws',
    redirect: '/custom/sdws/home',
    component: () => import('../views/custom/sdws/index.vue'),
    children: [
      {
        path: 'home',
        name: 'sdws-home',
        component: () => import('../views/custom/sdws/home.vue'),
      },
      {
        path: 'question',
        name: 'sdws-question',
        component: () => import('../views/custom/sdws/question.vue'),
      },
      // 规则页面
      {
        path: 'rule',
        name: 'sdws-rule',
        component: () => import('../views/custom/sdws/rule.vue'),
      },
      // 排名页面
      {
        path: 'rank',
        name: 'sdws-rank',
        component: () => import('../views/custom/sdws/rank.vue'),
      },
      // 结果页面
      {
        path: 'result',
        name: 'sdws-result',
        component: () => import('../views/custom/sdws/result.vue'),
      },
      // 奖品页面
      {
        path: 'reward',
        name: 'sdws-reward',
        component: () => import('../views/custom/sdws/reward.vue'),
      },
      // 记录页面
      {
        path: 'record',
        name: 'sdws-record',
        component: () => import('../views/custom/sdws/record.vue'),
      },
    ],
  },
  // 少儿答题-国学小名士
  {
    path: '/little-celebrity',
    name: 'LittleCelebrity',
    component: () => import('../views/little-celebrity/index'),
  },
  {
    path: '/little-rule',
    name: 'LittleRule',
    component: () => import('../views/little-celebrity/rule/index.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.afterEach((to, from) => {
  // 上报页面信息埋点
  const quesInfo = store.getters?.getQuesInfo

  let routerName = ''

  switch(to.name) {
    case 'home':
      routerName = '首页'
      break;
    case 'person-home':
      routerName = '我的答题'
      break;
    case 'competition-rank':
      routerName = '参赛排行'
      break;
    case 'person-rank':
      routerName = '个人成绩排行'
      break;
    case 'person-info':
      routerName = '个人信息'
      break;
    case 'person-record':
      routerName = '填报记录'
      break;
    case 'record-score-list':
      routerName = '积分记录'
      break;
    case 'record-score-list':
      routerName = '积分记录'
      break;
    case 'record-prize-list':
      routerName = '中奖记录'
      break;
    case 'result':
      routerName = '结果页'
      break;
    case 'ques-result':
      routerName = '结果页'
      break;
    case 'list':
      routerName = '列表页'
      break;
    case 'single':
      routerName = '单题展示页'
      break;
    case 'error':
      routerName = '错误页'
      break;
    case 'competition':
      routerName = '闯关竞赛页'
      break;
    case 'activity-home':
      routerName = '活动页'
      break;
    case 'activity-list':
      routerName = '单位列表页'
      break;
    case 'admin':
      routerName = '管理页'
      break;
    case 'tmpResult':
      routerName = '临时结果页'
      break;
    case 'sdws':
      routerName = '山东卫视页'
      break;

    default:
      routerName = '首页'
  }

  quesInfo && useQuesPageview({
    quesTitle: quesInfo.title,
    quesType: quesInfo.type,
    pageType: routerName
  })
})

export default router
